import React from "react";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./ExportDropdown.css";

const ExportDropdown = ({
  selectedLeadIds,
  filteredLeads,
  columns,
  tableRef,
  showToast = (msg, type) => console.log(msg, type),
}) => {
  const handleExportExcel = () => {
    try {
      const dataToExport =
        selectedLeadIds.length > 0
          ? filteredLeads.filter((row) =>
              selectedLeadIds.includes(row.id.toString())
            )
          : filteredLeads;

      const exportData = dataToExport.map((row) => {
        const rowData = {};
        columns.forEach((col) => {
          const key = col.Header;
          if (col.exportValue) {
            rowData[key] = col.exportValue(row);
          } else if (col.chipDropdownDisplay) {
            rowData[key] = col.chipDropdownDisplay(row);
          } else if (col.accessor) {
            rowData[key] = row[col.accessor];
          }
        });
        return rowData;
      });

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
      XLSX.writeFile(workbook, "leads_export.xlsx");
      showToast("Spreadsheet export successful!", "success");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      showToast("Error exporting spreadsheet.", "error");
    }
  };

  const handleExportPDF = async () => {
    if (!tableRef?.current) {
      console.error("Table reference not found.");
      showToast("Error exporting PDF: Table not found.", "error");
      return;
    }

    try {
      const canvas = await html2canvas(tableRef.current, {
        scale: 2, 
      });

      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "pt", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();

      const canvasHeight = canvas.height * (pdfWidth / canvas.width);

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, canvasHeight);
      pdf.save("table_screenshot.pdf");
      showToast("PDF export successful!", "success");
    } catch (error) {
      console.error("Error exporting PDF screenshot:", error);
      showToast("Error exporting PDF.", "error");
    }
  };

  return (
    <div className="export-dropdown">
      <button className="export-button" title="Export Data">
        Export
      </button>
      <div className="export-options">
        <div onClick={handleExportExcel} className="export-option">
          <FaFileExcel /> Export to Spreadsheet
        </div>
        <div onClick={handleExportPDF} className="export-option">
          <FaFilePdf /> Export PDF (Screenshot)
        </div>
      </div>
    </div>
  );
};

export default ExportDropdown;
